var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVk(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 34C26.3887 34 34 26.3888 34 17C34 7.61116 26.3887 0 17 0C7.61133 0 0 7.61116 0 17C0 26.3888 7.61133 34 17 34ZM9.42578 8.9V25H18.0278C20.1284 25 21.7461 24.5783 22.8809 23.735C24.0156 22.8917 24.583 21.757 24.583 20.331C24.583 18.951 24.0615 17.9007 23.0186 17.18C22.6602 16.9323 22.2559 16.7272 21.8052 16.5646C21.9976 16.4586 22.1797 16.3417 22.3516 16.214C23.3638 15.4473 23.8696 14.4123 23.8696 13.109C23.8696 11.775 23.3179 10.74 22.2139 10.004C21.125 9.26801 19.584 8.9 17.5908 8.9H9.42578ZM17.7749 21.205H14.7617V18.675H17.7749C18.2192 18.675 18.5493 18.7823 18.7637 18.997C18.9937 19.1963 19.1089 19.503 19.1089 19.917C19.1089 20.331 18.9937 20.653 18.7637 20.883C18.5493 21.0977 18.2192 21.205 17.7749 21.205ZM17.062 15.087H14.7617V12.695H17.062C17.522 12.695 17.8589 12.8023 18.0737 13.017C18.2886 13.2163 18.396 13.5153 18.396 13.914C18.396 14.2973 18.2886 14.5887 18.0737 14.788C17.8589 14.9873 17.522 15.087 17.062 15.087Z",
    fill: "#D4AF37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.1b4ecd7527f5f63f4c89e011c04a82ad.svg";
export { ForwardRef as ReactComponent };